<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" mx-auto>
        <v-card flat>
          <v-card-title class="px-0 py-2">
            <v-layout row wrap>
              <v-flex xs6>
                <v-dialog ref="dlgDate"
                persistent v-model="dlgDate"
                max-width="290px"
                :return-value.sync="lDate">
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="Date"
                  v-model="lDate" append-icon="mdi-calendar-today"
                  readonly clearable
                  v-on="on"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lDate"
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgDate = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgDate.save(lDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs2 class="text-left ml-2">
            <v-btn small fab class="accent" @click.native="loadAllDateByZone(lDate)">Go</v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout row wrap>
          <v-layout style="background-color: #a05a2c;">
            <v-flex xs2 mx-auto v-for="(zone, i) in zones" :key="i">
              <div class="pa-2 white--text text-center" style="font-size: 14px;">
                {{ zone }}
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <div style="border: 1px solid black;">
              <v-data-table
              :headers="header"
              :items="names"
              hide-default-footer
              disable-pagination
              :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="width: 246px; border-top: 1px solid black; border-right: 1px solid black;">{{ props.item.name }}</td>
                  <td style="width: 246px; border-top: 1px solid black; border-right: 1px solid black;"
                  v-for="(value, i) in props.item.values" :class="props.item.name === 'Attendance' ? value.value < '90%' ? 'red--text font-weight-black' : value.value > '98%' ? 'green--text font-weight-black' : 'orange--text font-weight-black' : ''">
                    {{value.value}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card-text>
</v-card>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<!-- loading -->
<div v-if="load" style="position:absolute; top:50%; left:40%">
  <v-progress-circular indeterminate color="info"></v-progress-circular>
</div>
</v-col>
</v-row>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      lDate: '',
      yesterdayDate: '',
      dlgDate: false,
      sbarMsg: '',
      sbar: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      sbarCol: 'error',
      names: [],
      zones: [],
      header: [
        { text: '', value: 'name', sortable: false }
      ],
      load: false
    }
  },
  mounted () {
    this.setTimer()
  },
  created () {
    var curDate = new Date()
    this.lDate = handy.formatDBDate(curDate)
    this.yesterdayDate = handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
    this.loadZones()
    this.loadAllDateByZone(this.lDate)
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
    },
    setTimer () {
      if (!this.load) {
        setInterval(this.loadAllDateByZone(this.lDate), 600000)
      }
    },
    loadAllDateByZone (curDate) {
      this.names = []
      var date = new Date(curDate)
      this.lDate = curDate
      this.yesterdayDate = handy.formatDBDate(new Date(date.setDate(date.getDate() - 1)))
      this.loadAttendanceByZone()
      .then(res => {
        this.loadStatsOfPendingInOut()
        .then(resp => {
          this.loadStatsOfManualAttendance()
          .then(respo => {
            this.loadWorkHoursMoreThan9Hours()
            this.loadStatsOfDailyReportAppSubTot()
            this.loadWorkHoursMoreThan16Hours()
            this.loadStatsOfSlaBreachedComp()
            this.loadStatsOfEmployeeUnDeployed()
            this.loadStatsOfEmployeeDeployed()
          })
        })
      })
    },
    loadZones () {
      this.zones = []
      this.axios.get(config.API_URL + '/getZones/')
      .then(response => {
        this.zones.push('Metrics Name')
        response.data.forEach(rec => {
          if (rec.zone_name) {
            this.zones.push(rec.zone_name)
            this.header.push(
              { text: 'Yesterday', value: rec.zone_name, sortable: false, class: 'text-center' },
              { text: 'Today', value: rec.zone_name, sortable: false, class: 'lighten-1 text-center' }
            )
          }
        })
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadAttendanceByZone () {
      return new Promise((resolve, reject) => {
        this.loading()
        var todayYestdates = []
        todayYestdates[0] = this.yesterdayDate
        todayYestdates[1] = this.lDate
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID,
            att_dt: todayYestdates
          }
        }
        this.axios.get(config.API_URL + '/getAttendanceBasedOnzone/', qry)
        .then(response => {
          var att = []
          if (response.data.length) {
            response.data.forEach(rec => {
              rec.percent = (rec.total_present ? Math.round((rec.total_present/ rec.total_staff) * 100) : '0') + '%'
              att.push({
                value: rec.percent,
                zone_id: rec.zone_id,
                date: rec.att_dt
              })
            })
          }
          this.names.push({
            name: 'Attendance',
            values: att
          })
          this.load = false
          resolve(true)
        })
        .catch(err => {
          this.msg(err, 0)
          this.load = false
          reject(false)
        })
      })
    },
    loadStatsOfPendingInOut () {
      return new Promise((resolve, reject) => {
        this.loading()
        var todayYestdates = []
        todayYestdates[0] = this.yesterdayDate
        todayYestdates[1] = this.lDate
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID,
            att_dt: todayYestdates
          }
        }
        this.axios.get(config.API_URL + '/getStatsOfPendingInOut/', qry)
        .then(response => {
          var pendingInAndOut = []
          if (response.data.length) {
            response.data.forEach(rec => {
              rec.pendingInOut = rec.tot_pend_in + '/' + rec.tot_pen_out
              pendingInAndOut.push({
                value: rec.pendingInOut
              })
            })
          }
          this.names.push({
            name: 'Pending In/Out',
            values: pendingInAndOut
          })
          this.load = false
          resolve(true)
        })
        .catch(err => {
          this.msg(err, 0)
          this.load = false
          reject(false)
        })
      })
    },
    loadStatsOfManualAttendance () {
      return new Promise((resolve, reject) => {
        this.loading()
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID,
            from_dt: this.yesterdayDate,
            to_dt: this.lDate
          }
        }
        this.axios.get(config.API_URL + '/getManualAttendance/', qry)
        .then(response => {
          var manualAtt = []
          response.data.forEach(rec => {
            manualAtt.push({
              value: rec.manual_in + '/' + rec.manual_out
            })
          })
          this.names.push({
            name: 'Manual Attendance(IN/OUT)',
            values: manualAtt
          })
          this.load = false
          resolve(true)
        })
        .catch(err => {
          this.msg(err, 0)
          this.load = false
          reject(false)
        })
      })
    },
    loadWorkHoursMoreThan9Hours () {
      this.loading()
      var todayYestdates = []
      todayYestdates[0] = this.yesterdayDate
      todayYestdates[1] = this.lDate
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: todayYestdates
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfMorethan9WorkHours/', qry)
      .then(response => {
        var moreThanninehrs = []
        if (response.data.length) {
          response.data.forEach(rec => {
            rec.morethan9hrs = rec.getMorethan9hrs ? rec.getMorethan9hrs : '0'
            moreThanninehrs.push({
              value: rec.morethan9hrs
            })
          })
        }
        this.names.push({
          name: 'OT > 9 Hours',
          values: moreThanninehrs
        })
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadWorkHoursMoreThan16Hours () {
      this.loading()
      var todayYestdates = []
      todayYestdates[0] = this.yesterdayDate
      todayYestdates[1] = this.lDate
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: todayYestdates
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfMorethan16WorkHours/', qry)
      .then(response => {
        var moreThansixteenhrs = []
        if (response.data.length) {
          response.data.forEach(rec => {
            rec.morethan16hrs = rec.getMorethan16hrs ? rec.getMorethan16hrs : '0'
            moreThansixteenhrs.push({
              value: rec.morethan16hrs
            })
          })
        }
        this.names.push({
          name: 'OT > 16 Hours',
          values: moreThansixteenhrs
        })
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadStatsOfDailyReportAppSubTot () {
      this.loading()
      var todayYestdates = []
      todayYestdates[0] = this.yesterdayDate
      todayYestdates[1] = this.lDate
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          c_date: todayYestdates
        }
      }
      this.axios.get(config.API_URL + '/getAppsubDailyReport/', qry)
      .then(response => {
        var dailyreport = []
        response.data.forEach(rec => {
          dailyreport.push({
            value: rec.is_approved + '/' + rec.is_submitted + '/' + rec.total_report
          })
        })
        this.names.push({
          name: 'Daily Report Approved/Submitted/Total',
          values: dailyreport
        })
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadStatsOfSlaBreachedComp () {
      this.loading()
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          from_dt: this.yesterdayDate,
          to_dt: this.lDate
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfSlaBreachedComp/', qry)
      .then(response => {
        var slaBreached = []
        response.data.forEach(rec => {
          slaBreached.push({
            value: rec.tot_sla_comp
          })
        })
        this.names.push({
          name: 'Total SLA Breached Complaints',
          values: slaBreached
        })
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadStatsOfEmployeeDeployed () {
      this.loading()
      var todayYestdates = []
      todayYestdates[0] = this.yesterdayDate
      todayYestdates[1] = this.lDate
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          deployed_on: todayYestdates
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfEmployeeDeployed/', qry)
      .then(response => {
        var deployedData = []
        response.data.forEach(rec => {
          deployedData.push({
            value: rec.deployed
          })
        })
        this.names.push({
          name: 'New Employees Deployed',
          values: deployedData
        })
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadStatsOfEmployeeUnDeployed () {
      this.loading()
      var todayYestdates = []
      todayYestdates[0] = this.yesterdayDate
      todayYestdates[1] = this.lDate
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          undeployed_on: todayYestdates
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfEmployeeUnDeployed/', qry)
      .then(response => {
        var undeployedData = []
        response.data.forEach(rec => {
          undeployedData.push({
            value: rec.undeployed_on
          })
        })
        this.names.push({
          name: 'Employees Undeployed',
          values: undeployedData
        })
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
